// extracted by mini-css-extract-plugin
export default {"text":"TimingBreakdown_text__usO6P"};